import { FeedbackRequestSchema } from "../../darvin-shared/dist/schema/zod/operations/feedback";
import { HttpFailedToFetchException } from "../model/httpException";
import { getAuthHeaders } from "../utils/authHeaders";
import { logException } from "../utils/logUtils";

export class FeedbackApi {
  private static readonly BASE_URL = import.meta.env.VITE_API_URL;
  private static readonly BASE_ENDPOINT = "feedback";

  static async sendFeedback(
    projectId: string,
    feedbackType: "bug report" | "feature request",
    feedbackMsg: string
  ): Promise<void> {
    try {
      const feedbackRequest = FeedbackRequestSchema.parse({
        project_id: projectId,
        feedback_type: feedbackType,
        feedback_message: feedbackMsg,
      });

      const headers = await getAuthHeaders({
        "Content-Type": "application/json",
      });

      const response = await fetch(`${this.BASE_URL}/${this.BASE_ENDPOINT}`, {
        method: "POST",
        headers,
        body: JSON.stringify(feedbackRequest),
      });

      if (!response.ok) {
        const errorText = await response.text();
        logException("Feedback API error (/feedback):", {
          status: response.status,
          statusText: response.statusText,
          body: errorText,
        });
        throw new HttpFailedToFetchException();
      }
    } catch (error) {
      throw new HttpFailedToFetchException();
    }
  }
}
